import type { Template } from "@/types";

export const PO_05_H3_V2: Template[] = [
    {
        id: "po-05-h3v2-01",
        name: "PO 01 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 31, y: 191, width: 279, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 191, width: 279, height: 401, rotation: 0, imageRotation: 0 },
            { id: "3", x: 724, y: 191, width: 436, height: 262, rotation: 0, imageRotation: 0 },
            { id: "4", x: 724, y: 458, width: 214, height: 134, rotation: 0, imageRotation: 0 },
            { id: "5", x: 946, y: 458, width: 214, height: 134, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-02",
        name: "PO 02 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 43, y: 145, width: 534, height: 317, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 469, width: 263, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 313, y: 469, width: 263, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 657, y: 191, width: 279, height: 401, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 191, width: 279, height: 401, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-03",
        name: "PO 03 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 44, y: 132, width: 539, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 476, width: 129, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 454, y: 476, width: 128, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 180, y: 476, width: 266, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 670, y: 223, width: 539, height: 337, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-04",
        name: "PO 04 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 30, y: 191, width: 279, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 316, y: 191, width: 279, height: 401, rotation: 0, imageRotation: 0 },
            { id: "3", x: 675, y: 145, width: 263, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 675, y: 321, width: 534, height: 317, rotation: 0, imageRotation: 0 },
            { id: "5", x: 946, y: 145, width: 263, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-05",
        name: "PO 05 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 164, width: 355, height: 224, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 164, width: 159, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 395, width: 159, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 166, y: 395, width: 355, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 529, y: 164, width: 723, height: 455, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-06",
        name: "PO 06 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 220, width: 497, height: 344, rotation: 0, imageRotation: 0 },
            { id: "2", x: 504, y: 220, width: 244, height: 344, rotation: 0, imageRotation: 0 },
            { id: "3", x: 755, y: 220, width: 244, height: 344, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1007, y: 220, width: 245, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1007, y: 395, width: 245, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-07",
        name: "PO 07 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 83, y: 124, width: 379, height: 533, rotation: 0, imageRotation: 0 },
            { id: "2", x: 469, y: 124, width: 418, height: 264, rotation: 0, imageRotation: 0 },
            { id: "3", x: 469, y: 395, width: 418, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 895, y: 124, width: 273, height: 354, rotation: 0, imageRotation: 0 },
            { id: "5", x: 895, y: 485, width: 273, height: 174, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-08",
        name: "PO 08 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 69, y: 107, width: 403, height: 568, rotation: 0, imageRotation: 0 },
            { id: "2", x: 479, y: 107, width: 294, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 479, y: 299, width: 294, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 479, y: 491, width: 294, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 781, y: 107, width: 403, height: 568, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-09",
        name: "PO 09 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 220, width: 498, height: 344, rotation: 0, imageRotation: 0 },
            { id: "2", x: 504, y: 220, width: 244, height: 344, rotation: 0, imageRotation: 0 },
            { id: "3", x: 755, y: 220, width: 245, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 755, y: 395, width: 245, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1008, y: 220, width: 244, height: 344, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-10",
        name: "PO 10 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 69, y: 107, width: 403, height: 568, rotation: 0, imageRotation: 0 },
            { id: "2", x: 479, y: 107, width: 403, height: 568, rotation: 0, imageRotation: 0 },
            { id: "3", x: 889, y: 107, width: 294, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 889, y: 299, width: 294, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 889, y: 491, width: 294, height: 185, rotation: 0, imageRotation: 0 }
        ],
    }
];